module.exports = __webpack_public_path__ + "static/domki-b891ac1e0ccee7fadc017a69fca1e393.jpg";